import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Hero.css";
import img1 from "./media/Gold12.png";
import { useMediaQuery } from "react-responsive";
import TextTransition, { presets } from "react-text-transition";

function Hero() {
  const isMobile = useMediaQuery({
    query: "(max-width: 500px)",
  });

  const TEXTS = [
    "Guaranteed Returns",
    "Online Success",
    "Exclusive Branding",
    "High SEO Value",
    "Trust and Credibility",
    "Versatile Use",
    "Global Recognition",
    "Market Differentiation",
    "Premium Perception",
    "Future-Proof Asset",
    "Enhanced Visibility",
    "Targeted Audience",
  ];

  const [index1, setIndex] = React.useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index1) => index1 + 1),
      2000 // every 3 seconds
    );
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="bg-[#eef4f9] ">
      <div className="container a-container  hero-padding">
        <div className="row min-h-[100vh] md:gap-0 gap-[2.5rem] md:pt-[80px]">
          <div className="col-12 col-xl-6 flex flex-col justify-center">
            <motion.div className="flex flex-col">
              <h1 className="hero-title-primary">
                <span className="text-[#fbcb04] gold-main">.GOLD Domains</span>{" "}
              </h1>
              <h1 className="hero-title-primary md:!text-[50px]">
                The New Age Asset!
              </h1>

              <p className="hero-title-sub !mb-[8px]">
                <span>Buy, Sell & Discover Premium .gold Domains</span>
              </p>
              <p>
                Welcome to the{" "}
                <span className="italic font-bold underline text-primary">
                  world&apos;s exclusive platform
                </span>{" "}
                for{" "}
                <span className="italic font-bold underline text-primary">
                  premium .gold domains.
                </span>
              </p>
              <p className="mb-[28px]">
                <span className="italic font-bold underline text-primary">
                  Invest for 10X returns
                </span>{" "}
                in our exclusive .gold domains collection
              </p>
              <div className="mb-[28px]">
                <span className="mb-[12px]">.Gold Domains ensure</span>
                &nbsp;&nbsp;{isMobile ? <br /> : " "}{" "}
                <TextTransition
                  springConfig={presets.wobbly}
                  className="font-['Open_sans'] !inline-block "
                >
                  <p className="py-[2px] px-[12px] bg-[#101c4c] rounded-full outline-[#fbcb04] outline-[4px]">
                    <span className="text-pent font-bold">
                      {TEXTS[index1 % TEXTS.length]}
                    </span>
                  </p>
                </TextTransition>
              </div>
              <div className="hero-buttons">
                <Link to="/Marketplace" className="hero-link">
                  <button className="w-full sm:!w-fit white-btn">
                    Explore Marketplace
                  </button>
                </Link>
                <Link to="/sell-your-dot-gold-domain" className="hero-link">
                  <button className="w-full sm:!w-fit white-btn !border-[#fae441]">
                    List Your Domain
                  </button>
                </Link>
              </div>
            </motion.div>
          </div>
          <div className="  d-md-none d-xl-flex col-12 col-xl-6 flex flex-col justify-center">
            <div className="flex flex-col justify-center items-end">
              <img src={img1} alt="Duotone" className="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
